import {
  AppConfig,
  AppConfigProvider,
  AppMachineProvider,
  CacheProvider,
  ServiceWorkerHandler,
} from "@indietabletop/appkit";
import { ReactNode } from "react";
import { ArmiesRulesetsFetcher } from "../armies-rulesets";
import { client } from "../client";
import { CompatGuard } from "../compat-guard";
import { database, DatabaseProvider } from "../database-provider";
import { FullscreenDismissBlocker } from "../fullscreen-dismiss-blocker";
import { GameContentLookupProvider } from "../game-content-provider";
import { KeywordsHandler } from "../keywords-handler";
import { UserSettingsFetcher } from "../user-settings";
import { fmt, hrefs, machine } from "./fmt";
import "./globals.css";
import icon from "./icon.png";
import { ScrollbarVisibility } from "./ScrollbarVisibility";

const appConfig: AppConfig = {
  app: { name: "Hobgoblin", icon },
  client: client,
  database: database,
  fmt: fmt,
  hrefs: hrefs,
  isDev: import.meta.env.DEV,
  placeholders: {
    email: "E.g. guruk@example.com",
  },
};

export function RootLayout(props: { children: ReactNode }) {
  const { children } = props;

  return (
    <CompatGuard>
      <AppConfigProvider config={appConfig}>
        <ServiceWorkerHandler path="/sw.js">
          <DatabaseProvider>
            <AppMachineProvider value={machine}>
              <GameContentLookupProvider>
                <ArmiesRulesetsFetcher>
                  <UserSettingsFetcher>
                    <KeywordsHandler>
                      <FullscreenDismissBlocker />
                      <ScrollbarVisibility />

                      <CacheProvider>{children}</CacheProvider>
                    </KeywordsHandler>
                  </UserSettingsFetcher>
                </ArmiesRulesetsFetcher>
              </GameContentLookupProvider>
            </AppMachineProvider>
          </DatabaseProvider>
        </ServiceWorkerHandler>
      </AppConfigProvider>
    </CompatGuard>
  );
}
